<!-- Copyright (c) 2022 VMware, Inc. All rights reserved. VMware Confidential -->
<div *ngIf="show" class="clr-spinner-container">
    <clr-spinner></clr-spinner>
</div>